/**
 * "Need it sooner?" copy shown beneath the result grid when the recommended
 * pant is Beatrice (which is pre-launch). Offers the Mila pant as the closest
 * buy-now alternative with three differentiators so the customer can decide
 * between waiting for Beatrice or getting Mila today.
 *
 * This file only applies while Beatrice is in pre-launch. Once the
 * `comingSoon` flag is removed from the Beatrice entry in products.ts, the
 * result screen stops rendering this section and the import can be deleted.
 */
export const BEATRICE_ALT = {
  heading: 'Need it sooner? Your next best match is our Mila.',
  intro:
    "Our Mila is the closest cut to Beatrice in the current range. Here's how the two differ so you can decide between waiting or buying now.",
  /**
   * Three differentiators. Kept concrete and neutral - not "Mila is better"
   * but "here's what's different" - so the customer chooses on fit criteria
   * rather than a sales push.
   */
  bullets: [
    'Mila has our 4-point internal waist adjustment for a closer cinch; Beatrice uses a 2-point system for a more relaxed line.',
    'Mila has heat-activated stretch panels through the waist - extra give when you bend, sit, and reach. Beatrice sits with less panelled volume for a quieter silhouette.',
    'Mila comes in Short, Regular, and Tall; Beatrice launches in Short and Regular only.',
  ],
} as const
